module.exports = "pegasus/assets/theme3/theme3_theme.png";